<template>
  <div>
    <consulting-heumtax v-if="!partnerContent.name" />
    <consulting-fastfive v-else-if="partnerContent.name === 'fastfive'" />
    <consulting-partner v-else />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import ConsultingHeumtax from '~/components/consulting/consulting-heumtax.vue'
import ConsultingFastfive from '~/components/consulting/consulting-fastfive.vue'
import ConsultingPartner from '~/components/consulting/consulting-partner.vue'

export default {
  layout: 'invert-font-header',
  head: {
    title: '서비스 상담 신청하기 - 세무법인혜움'
  },
  components: {
    ConsultingHeumtax,
    ConsultingFastfive,
    ConsultingPartner
  },
  computed: {
    ...mapGetters({
      partnerContent: 'getPartnerContent'
    })
  }
}
</script>
<style lang="scss"></style>
